import { Component } from '@angular/core';
import { GlobalService } from 'src/app/Services/global.service';
import { Router,ActivatedRoute} from '@angular/router';
import { FormGroup,FormControl,Validators } from '@angular/forms';
import { getLocalJSON } from '../../_helpers/storage.util';
declare var $:any;

@Component({
  selector: 'app-bankdetail',
  templateUrl: './bankdetail.component.html',
  styleUrls: ['./bankdetail.component.scss']
})
export class BankdetailComponent {

  public loading:boolean = false;
  public submitted:boolean = false;
  public detail :any=[];
  public currentUrl:any=this.router.url;
  public userTypeList:any =[];
  public countryList:any=[];
  public country:any='';
  public showview:boolean=false;
  // public country_currency: string = '';
  public loginDetail:any =[];


  bankData = new FormGroup({
    name:new FormControl('',Validators.compose([
      Validators.required,Validators.pattern('^[a-zA-Z \-\']+')])),
    type:new FormControl('',Validators.compose([
      Validators.required ])),
    currency:new FormControl('',Validators.compose([
      Validators.required])),
    number:new FormControl('',Validators.compose([
      Validators.required,Validators.minLength(6) , Validators.maxLength(20)])),
    country:new FormControl('',Validators.compose([
      Validators.required])),
    r_number:new FormControl('',Validators.compose([
      Validators.required,Validators.minLength(9) ])),  
  })
  
   get f() { return this.bankData.controls; }

   constructor(public router: Router, public service: GlobalService) { 
    this.loginDetail = getLocalJSON('grw_login'); 
    $('#text23').trigger('click');
    this.checks();
    // this.getRoles();
    this.getCountry();
    // this.getBankDetail();

    if(this.currentUrl=='/edit-bank-detail'){
      this.getBankDetail();
    }  else {
     this.showview =true;
    }
    
  }

  ngOnInit(): void {
  
  }

  checks(){
    if(this.loginDetail.user_role_type ==3){
      this.detail.account_holder_type='individual';
      this.bankData.controls["type"].setValue('individual');
      this.showview = true;
    } else {
      this.detail.account_holder_type='company';
      this.bankData.controls["type"].setValue('company');
      this.showview = true;
    }
  }

  Onsubmit(){
    this.submitted = true;    
      let userdetail = this.bankData;
      if(userdetail.valid){
        this.loading=true;
        var url="/bank-account";
        var detail={
          "account_holder_name": userdetail.value.name,
          "routing_number": userdetail.value.r_number,
          "account_number": userdetail.value.number,
          "currency": userdetail.value.currency,
          "country": this.country,
          "account_type": userdetail.value.type
        };
        this.service.PostApis(detail,url).subscribe(((response:any)=>{
          if(response.success ==1){  
            if(this.detail._id !=undefined){
              this.DeleteAccount();
            }  
            this.loginDetail.bank_account_added=true;
            localStorage.setItem('grw_login',<any> JSON.stringify(this.loginDetail));       
            this.router.navigate(['/profile']);
            this.submitted = false;  
            this.loading=false;        
          } else {
            this.service.dangerAlert(response.message);
            this.loading=false;
          }
        }), (error:any) => {
          this.loading=false;
        });
      } else{
        window.scroll(0,0);
      }
  }

  getBankDetail(){
    const url = "/get-bank-account"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        this.getState( response.data[0].country,2)
        this.detail = response.data[0];
        this.detail.account_number = 'XXXXXXXX'+response.data[0].last4;       
      }
    }), (error) => { this.loading =false; });
  }

  getRoles(){
    const url = "/get-roles"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        this.userTypeList = response.data;
      }
    }), (error) => { this.loading =false; });
  }

  getCountry(){
    const url = "/country"; 
    this.service.GetApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
        this.countryList = response.data;
      }
    }), (error) => { this.loading =false; });
  }

  getState(event:any,type:any) {
    var mm :any='',self=this;
    if(type==1){
      mm= event.value;
    } else {
      mm= event;
    } 
    this.countryList.filter((el:any)=>{
      if(type==1){
        if(el._id == mm){
          self.bankData.controls["currency"].setValue(el.currency);
          self.country=el.code;
        }
        this.showview = true;

      } else {
        if(el.code == mm){
          self.detail.countrys=el._id;
          self.country=el.code;
          self.bankData.controls["country"].setValue(el._id);
          self.bankData.controls["currency"].setValue(el.currency);
          // self.bankData.controls["country"].setValue(el._id);
          
        }
        this.showview = true;

      }
    
    }) 
  }

  DeleteAccount(){
    const url = "/bank-delete?bank_account_id="+this.detail._id; 
    this.service.DeleteApi(url).subscribe(((response:any)=>{
      if(response.success ==1) {
      }
    }), (error) => { this.loading =false; });
  }
}


